<template>
  <div class="settings-form-container">
    <div class="settings-form">
      <h2>{{ $t("settings.title") }}</h2>
      <el-form
        :model="form"
        :rules="rules"
        ref="formRef"
        @submit.prevent="handleSave"
        label-position="top"
      >
        <el-form-item :label="$t('settings.username')" prop="name">
          <el-input
            v-model="form.name"
            :placeholder="$t('settings.usernamePlaceholder')"
          />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" disabled>
            <template #append
              ><el-button type="success" @click="console.log(123)"
                >修改</el-button
              ></template
            >
          </el-input>
        </el-form-item>
        <el-collapse v-model="activeNames">
          <el-collapse-item title="修改密码" name="1">
            <el-form-item :label="$t('settings.password')" prop="password">
              <el-input type="password" v-model="form.password" />
            </el-form-item>
            <el-form-item
              :label="$t('settings.newPassword')"
              prop="newPassword"
            >
              <el-input type="password" v-model="form.newPassword" />
            </el-form-item>
            <el-form-item
              :label="$t('settings.confirmPassword')"
              prop="confirmNewPassword"
            >
              <el-input type="password" v-model="form.confirmNewPassword" />
            </el-form-item>
          </el-collapse-item>
        </el-collapse>

        <el-form-item label="身份" prop="identity">
          <el-select
            v-model="form.identity"
            clearable
            style="width: 240px"
            placeholder="请选择"
            disabled
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('settings.avatar')">
          <el-upload
            class="avatar-uploader"
            :action="UpdateApi"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :limit="1"
            :file-list="fileList"
            :disabled="allowUpload"
          >
            <el-image
              :src="imageUrl"
              v-if="imageUrl"
              class="avatar"
              alt=""
              :fit="'contain'"
            >
              <template #error>
                <div class="image-slot">
                  <el-icon><icon-picture /></el-icon>
                </div>
              </template>
            </el-image>
            <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="allowUpload">
          <el-button type="warning" @click="clearImage">{{
            $t("settings.clearImg")
          }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSave">
            {{ $t("settings.save") }}
          </el-button>
          <el-button type="danger" @click="$router.back(-1)">
            {{ $t("settings.back") }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { ElMessage } from "element-plus";
import { Picture as IconPicture, Plus } from "@element-plus/icons-vue";

export default defineComponent({
  name: "SettingsForm",
  data() {
    return {
      form: {
        name: "",
        password: "",
        newPassword: "",
        confirmNewPassword: "",
        identity: "",
        email: "",
      },
      imageUrl: "",
      fileList: [],
      activeNames: "",
      options: [
        {
          value: "学生",
          label: "学生",
        },
        {
          value: "老师",
          label: "老师",
        },
        {
          value: "机构",
          label: "机构",
        },
        {
          value: "体验者",
          label: "体验者",
        },
      ],
    };
  },
  components: {
    Plus,
    IconPicture,
  },
  mounted() {
    this.imageUrl = this.$store.state.user.avatar;
    this.form.name = this.$store.state.user.name;
    this.form.email = this.$store.state.user.email;
    this.form.identity = this.$store.state.user.type;
  },
  methods: {
    handleSave() {
      if (this.activeNames.length == 2) {
        this.$refs.formRef.validate((valid: any) => {
          if (valid) {
            this.$store
              .dispatch("user/UpdateUser", {
                name: this.form.name,
                password: this.form.confirmNewPassword,
                headPic: this.imageUrl,
                type: this.form.identity,
              })
              .then(() => {
                ElMessage.success("修改成功");
                this.$router.push("/");
              })
              .catch(() => {});
          }
        });
      } else {
        this.$store
          .dispatch("user/UpdateUser", {
            name: this.form.name,
            headPic: this.imageUrl,
            type: this.form.identity,
          })
          .then(() => {
            ElMessage.success("修改成功");
            this.$router.push("/");
          })
          .catch(() => {});
      }
    },
    beforeAvatarUpload(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElMessage.error("Avatar must be JPG/PNG format!");
        return false;
      }
      if (!isLt2M) {
        ElMessage.error("Avatar size can not exceed 2MB!");
        return false;
      }

      // Display uploaded avatar
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageUrl = reader.result as string;
      };

      return true;
    },
    handleAvatarSuccess(response: any) {
      this.imageUrl = response.data.returnFileUrl;
    },
    clearImage() {
      this.imageUrl = "";
      this.fileList = [];
    },
  },
  computed: {
    rules() {
      return {
        name: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "用户名长度在 3 到 15 个字符",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              const pattern = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
              if (!pattern.test(value)) {
                callback(new Error("用户名只能包含中文、大小写字母和数字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          {
            min: 6,
            max: 12,
            message: "新密码必须在6到12位之间",
            trigger: "blur",
          },
        ],
        confirmNewPassword: [
          { required: true, message: "确认新密码不能为空", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.newPassword) {
                callback(new Error("两次输入的新密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      };
    },
    allowUpload() {
      return this.imageUrl !== "";
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
});
</script>

<style scoped>
h2 {
  margin-bottom: 20px;
}
.settings-form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.settings-form {
  width: 100%;
  max-width: 400px;
  padding: 2em;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.avatar-uploader {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
</style>
